import * as React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Banner from "../components/home/banner"
import Intro from "../components/home/intro"
import Testimonials from "../components/testimonials/slider"
import Steps from "../components/home/steps"
import Cta from "../components/home/cta"
import Info from "../components/info/info"
import LatestNews from "../components/news/latest"

import { graphql } from "gatsby"

export const query = graphql`
  {
    allStrapiBlogs {
      edges {
        node {
          Heading
          Slug
          Body
          FeaturedImage {
            publicURL
          }
        }
      }
    }
    strapiHome {
      Seo {
        metaTitle
        metaDescription
        keywords
      }
      HomeCtaStrip {
        Text
        ButtonText
        ButtonLink
        BackgroundImage {
          publicURL
        }
      }
      Heading
      SubHeading
      BannerImage {
        publicURL
      }
      Summary
      ButtonText
      ButtonLink
      IntroHeading
      IntroBody
      Cards {
        Image {
          publicURL
        }
        Text
        ButtonLink
        ButtonText
        BackgroundImage {
          publicURL
        }
      }
      SecondIntroBody
      Buttons {
        ButtonText
        ButtonLink
      }
      Testimonials {
        Body
        Name
        Company
        Image {
          publicURL
        }
      }
      StepsHeading
      Steps {
        BackgroundImage {
          publicURL
        }
        Image {
          publicURL
        }
        Text
      }
      ListHeading
      ListBody
      ListImage {
        publicURL
      }
    }
  }
`

const IndexPage = ({ data }) => (
  <Layout slug={`/`}>
    <Seo
      title={data.strapiHome.Seo.metaTitle}
      description={data.strapiHome.Seo.metaDescription}
      keywords={data.strapiHome.Seo.keywords}
    />
    <Banner data={data.strapiHome}></Banner>
    <Intro data={data.strapiHome}></Intro>
    <Testimonials data={data.strapiHome}></Testimonials>
    <Steps data={data.strapiHome}></Steps>
    <Cta data={data.strapiHome.HomeCtaStrip}></Cta>
    <Info data={data.strapiHome}></Info>
    <LatestNews data={data.allStrapiBlogs.edges}></LatestNews>
  </Layout>
)

export default IndexPage
